import * as React from 'react';
import { observable, computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { IAppOnlyStore } from '../../stores';
import { ESettingStatus } from '../../../../common/interfaces/configuration';
import { PortalSearchBarField } from '../../components/layout';
import { Button, EButtonType } from '../../components/action';

// Styles
const s = require('./Configuration.css');

// Props
interface IConfigurationSettingProps extends IAppOnlyStore {
    settingKey: string;
    value: string;
    description: string;
    isRequired: boolean;
    status: ESettingStatus;
}

// Component
@inject('store')
@observer
export class ConfigurationSetting extends React.Component<IConfigurationSettingProps, {}> {
    constructor(props: IConfigurationSettingProps) {
        super(props);
    }

    @observable modifiedValue: string = null;

    @computed
    private get isModified(): boolean {
        return this.modifiedValue !== null && this.props.value !== this.modifiedValue;
    }

    public render() {
        return (
            <div className={s.fieldWrapper}>
                <label className={s.fieldLabel} htmlFor={this.props.settingKey}>
                    {this.props.description || ''}
                </label>

                <div className={s.fieldGroup}>
                    <PortalSearchBarField
                        onChange={this.handleValueChange}
                        inputId={this.props.settingKey}
                        name={this.props.settingKey}
                        field={this.props.settingKey}
                        value={this.modifiedValue !== null ? this.modifiedValue : this.props.value}
                        lightness={4}
                    />

                    <Button
                        onClick={this.handleChangedValueSave}
                        type={
                            this.props.status === ESettingStatus.Success
                                ? EButtonType.Success
                                : this.isModified ? EButtonType.Action : EButtonType.BorderOnly
                        }
                        inBox={true}
                    >
                        {this.props.status === ESettingStatus.Saving
                            ? 'Saving...'
                            : this.props.status === ESettingStatus.Success
                              ? 'Change saved'
                              : this.props.status === ESettingStatus.Error
                                ? 'Could not save, try again'
                                : this.isModified ? 'Save changes' : ''}
                    </Button>
                </div>
            </div>
        );
    }

    private handleValueChange = (field: string, value: string) => {
        this.modifiedValue = value;
    };

    private handleChangedValueSave = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (
            this.isModified &&
            this.props.status !== ESettingStatus.Saving &&
            (this.props.isRequired === false || (this.props.isRequired && this.modifiedValue.trim().length > 0))
        ) {
            this.props.store.configuration.saveChangedValue(this.props.settingKey, this.modifiedValue).then(() => {
                this.modifiedValue = null;
            });
        }

        return true;
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/admin/ConfigurationSetting.tsx